<div class="selvitys">
  <div class="otsake" [class.kuititon]="kortti.tyyppi === 'kuititon'">
    @if (kortti.tyyppi !== 'kuititon') {
      <div class="esikatselu">
        @if (esikatselukuvaUrl()) {
          <img [src]="esikatselukuvaUrl()" crossorigin="use-credentials" loading="lazy" alt="" />
        } @else {
          <div class="esikatselu-tyhja"><span></span><span></span><span></span><span></span><span></span><span></span></div>
        }
      </div>
    } @else {
      <div class="esikatselu esikatselu-kysymys">
        <mat-icon>help_outline</mat-icon>
      </div>
    }

    <div>
      <div class="maksunsaaja">{{ kortti.maksunsaaja || kortti.viesti }}</div>
      <div class="pvm">{{ kortti.pvml | lokaalipvm | async }}</div>
      @if (kortti.kirjauksenViesti) {
        <div class="kirjauksen-viesti">{{ kortti.kirjauksenViesti }}</div>
      }
    </div>

    <div class="summa">{{ kortti.summa | lmoney: 'EUR' | async }}</div>
  </div>

  <div class="erotin"></div>

  <span class="tunniste">
    <mat-icon class="tunniste-ikoni">info</mat-icon>
    @if (kortti.tyyppi !== 'kuititon') {
      {{ 'tositteet.selvitys.tarvitaan-lisatietoja' | translate | async }}
    } @else {
      {{ 'tositteet.selvitys.tosite-puuttuu' | translate | async }}
    }
  </span>
  <div class="kysymys">{{ kortti.kysymys }}</div>

  @if (tositeAvain) {
    <div class="toiminnot">
      <app-button (click)="avaaTosite()" actionId="Selvityspyyntö: avaa tosite" [actionContext]="[kortti.avain]" additionalClass="avaa-tosite" matIcon="receipt_long">Avaa tosite</app-button>
    </div>
  }
</div>
